__turbopack_context__.v({
  "arrow": "_5ziQeW_arrow",
  "dropdown": "_5ziQeW_dropdown",
});
